module.exports = __webpack_public_path__ + "img/26.2d5bef44.svg";